import { render } from "./absen-list-virtual-scroll.vue?vue&type=template&id=9aa21c12"
import script from "./absen-list-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./absen-list-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__